import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { QuotationStatsDto } from "../../../shared/dtos/quotation/QuotationStatsDto";

interface QuotationWidgetProps {
  data: QuotationStatsDto;
}

const QuotationWidget: React.FC<QuotationWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("QUOTATION");
  const Icon = meta.icon;

  const conversionRate =
    data.createdToday > 0
      ? ((data.convertedToday / data.createdToday) * 100).toFixed(1)
      : 0;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Quoted Value
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "warning.main" }}
          >
            {formatCurrency(data.totalQuotationValueToday)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 2,
            textAlign: "center",
          }}
        >
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Created
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              {data.createdToday}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Converted
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "success.main" }}
            >
              {data.convertedToday}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Rate
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              {conversionRate}%
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default QuotationWidget;
